import { IImage, IVideo } from 'shared/models/media';
import { IUserAuthInfo } from 'shared/models/user-auth-info';

export enum ECommentPermission {
  All = 0, // 显示评论区
  Follower = 1, // 粉丝可评论
  Self = 2, // 自己可评论
  Disable = 3, // 不可评论，不显示评论区
  Friend = 4, // 好友可评论
}

export interface GalleryLabelType {
  direction: string;
  id: string;
  imageIndex: number;
  name: string;
  type: string;
  xPct: number;
  yPct: number;
}

export enum EArticleClass {
  GALLERY = 'Gallery',
  VIDEO = 'Video',
  ARTICLE = 'Article',
}

export interface IIllegalInfo {
  warningLabel: string;
  warningLabelType: number;
}

export interface IArticleDetail {
  groupId: string;
  templateId?: string;
  imprId?: string;

  // author
  author: {
    userId: string;
    avatar: string;
    authInfo: IUserAuthInfo;
    nickName: string;
    linkName: string;
  };

  // content
  articleClass: EArticleClass;

  title: string;
  content: string;
  shortContent: string;

  // content publish time
  publishTime: number;
  modifyTime?: number;

  // interaction
  readCount: number;
  diggCount: number;
  favoriteCount: number;
  commentCount: number;

  // legacy hashtag
  forumList?: {
    id: string;
    name: string;
  }[];

  // poi
  locationInfo?: {
    poiId: string;
    poiName: string;
    poiArea?: string;
  };

  // search after read
  relatedQuery?: string;

  // privacy & safety
  isOnlyFollow: boolean;
  commentPermission: ECommentPermission;
  illegalInfo?: IIllegalInfo;
}

export interface IVideoArticleDetail extends IArticleDetail {
  articleClass: EArticleClass.VIDEO;
  largeImage: IImage;
  video: IVideo & { encryptedUrl?: string; ocr?: string[] };
}

export interface IGalleryArticleDetail extends IArticleDetail {
  articleClass: EArticleClass.GALLERY;
  imageList: IImage[];
  galleryLabels: GalleryLabelType[];
}

export interface IRichArticleDetail extends IArticleDetail {
  articleClass: EArticleClass.ARTICLE;
  largeImage: IImage;
}

export type TArticleDetail = IVideoArticleDetail | IGalleryArticleDetail | IRichArticleDetail;

export enum EArticleUnavailableReason {
  NOT_FOUND = 'not_found',
  PRIVATE_ACCOUNT = 'private_account',
  SERVER_ERROR = 'server_error',
}

export interface IArticleUnavailableDetail {
  groupId: string;
  unavailableReason: EArticleUnavailableReason;
}

export const ArticleDetailUtil = {
  isAvailable: (article: TArticleDetail | IArticleUnavailableDetail): article is TArticleDetail => {
    return !('unavailableReason' in article);
  },
  getCoverImage: (article: TArticleDetail): IImage => {
    switch (article.articleClass) {
      case EArticleClass.GALLERY:
        return article.imageList[0];
      case EArticleClass.ARTICLE:
      case EArticleClass.VIDEO:
      default:
        return article.largeImage;
    }
  },
};
